export enum MovementScheduleColumnIndexes {
    CLOSE_VALUE = 'closeValue',
    FIRST_COLUMN = 'column1',
    SECOND_COLUMN = 'column2',
    THIRD_COLUMN = 'column3',
    FORTH_COLUMN = 'column4',
    OPEN_VALUE = 'openValue',
}
